export default theme => {
    return {}
}


// WEBPACK FOOTER //
// ./src/app/configuration/ChickFilA/theme/components/scorecard/ScorecardView/ScorecardExport.js